import { PREMIUM_ADS_HINT_KEY, PREMIUM_ADS_HINT_OFF } from '@/lib/ads/journey-tag'

/**
 * Whether Mediavine Journey may serve ads on the current page, read from the
 * same two signals the ad stack itself reads, so analytics can never drift
 * from the real ad decision:
 *
 * 1. The per-page blocklist marker (`components/ads/mediavine-blocklist.tsx`).
 *    The Journey wrapper scans the DOM for this element; `data-blocklist-all`
 *    suppresses every unit. It is rendered by the homepage, the identify and
 *    diagnose funnel, auth, pricing, checkout, not-found pages, /grass-atlas,
 *    /studio, and featured directory company pages. The adhesion-only marker
 *    leaves in-content ads on, so it does not make a page ineligible.
 * 2. The premium ad-free hint (`lib/ads/journey-tag.ts`). The <head> loader
 *    never injects the Journey tag when it reads `off`, and the tag is decided
 *    once per document load.
 */
export const MEDIAVINE_CONFIG_MARKER_ID = 'ad-management-config-settings'
export const MEDIAVINE_BLOCK_ALL_ATTR = 'data-blocklist-all'

export function pageHasBlockAllMarker(doc: Document): boolean {
  try {
    const markers = doc.querySelectorAll(`#${MEDIAVINE_CONFIG_MARKER_ID}`)
    for (const marker of Array.from(markers)) {
      if (marker.getAttribute(MEDIAVINE_BLOCK_ALL_ATTR) === '1') return true
    }
    return false
  } catch {
    return false
  }
}

/** The premium hint as the Journey loader saw it when this document loaded. */
export function readPremiumAdFreeHint(storage: Pick<Storage, 'getItem'> | null): boolean {
  try {
    return storage?.getItem(PREMIUM_ADS_HINT_KEY) === PREMIUM_ADS_HINT_OFF
  } catch {
    return false
  }
}

export function adsEligible(doc: Document, premiumAdFreeAtLoad: boolean): boolean {
  if (premiumAdFreeAtLoad) return false
  return !pageHasBlockAllMarker(doc)
}
